import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { MotionConfig } from "framer-motion";
import "@/index.css";
import App from "@/App";

function Root() {
  useEffect(() => {
    // Signal the prerender driver that the SPA has fully hydrated
    // (used by /scripts/prerender.py to know when to capture the DOM).
    if (typeof window !== "undefined") {
      // Defer one tick to let async data fetches settle.
      const id = setTimeout(() => {
        window.__APP_HYDRATED__ = true;
      }, 800);
      return () => clearTimeout(id);
    }
  }, []);
  return (
    <HelmetProvider>
      <MotionConfig reducedMotion="user">
        <App />
      </MotionConfig>
    </HelmetProvider>
  );
}

const container = document.getElementById("root");
// We always use createRoot — not hydrateRoot.
//
// Rationale: every page is prerendered to static HTML for crawlers and for
// view-source readability. Real browsers receive the same prerendered HTML
// (fast first paint with real content) and then React mounts on top and
// replaces the DOM with the live SPA. createRoot avoids the entire class of
// hydration-mismatch warnings that React 19 emits when a JSX subtree's
// rendered output differs from the serialised prerendered DOM (browser
// inline-style normalisation, framer-motion final vs initial states, dev
// babel attrs, etc.). The visual swap is invisible to the user because the
// prerendered markup and the React mount produce the same DOM tree.
const root = ReactDOM.createRoot(container);
root.render(<React.StrictMode><Root /></React.StrictMode>);
